import { ILayout } from '../../../../../../models/admin';

//raw data for mobile layout
const mobileLayoutData = {
  propInfo: [
    {
      name: 'Page Audio',
      inputType: 'audio',
      binding: 'audio',
      value: '',
      label: 'Audio',
    },
  ],
  sections: [],
  height: null,
  width: null,
  rowCount: 150,
  colCount: 70,
  cellWidth: 3.77,
  cellHeight: 3.77,
  defaultScreenSize: { label: 'Mobile', width: 15, height: 7, unit: 1 },
  scale: [1, 1],
};
const webLayoutData = {
  propInfo: [
    {
      name: 'Page Audio',
      inputType: 'audio',
      binding: 'audio',
      value: '',
      label: 'Audio',
    },
  ],
  sections: [],
  height: null,
  width: null,
  rowCount: 300,
  colCount: 150,
  cellWidth: 3.77,
  cellHeight: 3.77,
  defaultScreenSize: { label: 'Desktop', width: 30, height: 15, unit: 1 },
  scale: [1, 1],
};
const tabletLayoutData = {
  propInfo: [
    {
      name: 'Page Audio',
      inputType: 'audio',
      binding: 'audio',
      value: '',
      label: 'Audio',
    },
  ],
  sections: [],
  height: null,
  width: null,
  rowCount: 200,
  colCount: 100,
  cellWidth: 3.77,
  cellHeight: 3.77,
  defaultScreenSize: { label: 'Tablet', width: 20, height: 10, unit: 1 },
  scale: [1, 1],
};

export const defaultMobileLayout: any = {
  Name: 'mobile',
  Cols: 150,
  Rows: 70,
  Data: JSON.stringify({ ...mobileLayoutData, rowCount: 70, colCount: 150 }),
  Sections: [],
};

export const defaultWebLayout = {
  Name: 'web',
  Cols: 300,
  Rows: 150,
  Data: JSON.stringify({ ...webLayoutData, rowCount: 150, colCount: 300 }),
  Sections: [],
};

export const defaultTabletLayout = {
  Name: 'tablet',
  Cols: 200,
  Rows: 100,
  Data: JSON.stringify({ ...tabletLayoutData, rowCount: 100, colCount: 200 }),
  Sections: [],
};

export const exampleLayoutWithSections = {
  propInfo: [
    {
      name: 'Page Audio',
      inputType: 'audio',
      binding: 'audio',
      value: '',
      label: 'Audio',
    },
  ],
  sections: [
    {
      row: 3,
      col: 1,
      height: 84.5625,
      width: 384.625,
      name: 'Rich Text',
      type: 'richText',
      textContent: '',
      id: 'dtgrhq',
      selected: false,
      rowCount: 15,
      colCount: 34,
      options: [],
      x: 11.3125,
      y: 11.27500057220459,
      propInfo: [
        {
          name: 'Show Scrollbar',
          inputType: 'dropdown',
          binding: 'style.overflow',
          options: [
            {
              label: 'Show',
              value: 'auto',
            },
            {
              label: 'hide',
              value: 'hidden',
            },
          ],
          value: 'hidden',
          label: 'Scroll Visible',
        },
        {
          name: 'Audio',
          inputType: 'audio',
          binding: 'audio',
          value: '',
          label: 'Audio',
        },
        {
          name: 'Border Color',
          inputType: 'color',
          binding: 'style.borderColor',
          value: 'black',
          label: 'Border Color',
        },
        {
          name: 'Border Type',
          label: 'Border Type',
          inputType: 'dropdown',
          options: [
            {
              label: 'Solid',
              value: 'solid',
            },
            {
              label: 'Dotted',
              value: 'dotted',
            },
            {
              label: 'Dashed',
              value: 'dashed',
            },
            {
              label: 'Double',
              value: 'double',
            },
            {
              label: 'Groove',
              value: 'groove',
            },
            {
              label: 'Ridge',
              value: 'ridge',
            },
            {
              label: 'Inset',
              value: 'inset',
            },
            {
              label: 'Outset',
              value: 'outset',
            },
          ],
          binding: 'style.borderStyle',
          value: 'solid',
        },
        {
          name: 'Border Radius',
          inputType: 'number',
          binding: 'style.borderRadius',
          value: '0px',
          label: 'Border Radius',
        },
        {
          name: 'Border Width',
          inputType: 'number',
          binding: 'style.borderWidth',
          value: '1px',
          label: 'Border Width',
        },
        {
          name: 'Rotation',
          inputType: 'number',
          binding: 'style.transform',
          value: 0,
          label: 'Rotation',
        },
        {
          name: 'padding',
          inputType: 'number',
          binding: 'style.padding',
          value: '0',
          hidden: false,
          label: 'Padding',
        },
        {
          name: 'background',
          inputType: 'gradientcolor',
          binding: 'style.background',
          value: 'linear-gradient(90deg, #ff0000 50%, #0000ff 100%)',
          label: 'Background',
        },
        {
          name: 'innerHTML',
          inputType: 'text',
          binding: 'innerHTML',
          hidden: true,
          value:
            '<div class="ql-editor section"><p><span style="font-size: 36px;">test case test case</span></p></div>',
          label: 'Rich Text Content',
        },
        {
          name: 'delta',
          inputType: 'none',
          binding: 'delta',
          value: {
            ops: [
              {
                attributes: {
                  size: '36px',
                },
                insert: 'test case test case',
              },
              {
                insert: '\n',
              },
            ],
          },
          label: 'Rich Text Content',
        },
      ],
      isLocked: false,
    },
    {
      row: 19,
      col: 1,
      height: 56.37500286102295,
      width: 384.625,
      name: 'Rectangle',
      type: 'rectangle',
      textContent: '',
      id: 'stas1z',
      selected: false,
      rowCount: 10,
      colCount: 34,
      options: [],
      x: 11.3125,
      y: 101.47500514984131,
      propInfo: [
        {
          name: 'background',
          inputType: 'gradientcolor',
          binding: 'style.background',
          value: 'linear-gradient(120deg, #ff0000 50%, #0000ff 100%)',
          label: 'Background',
        },
        {
          name: 'Rotation',
          inputType: 'number',
          binding: 'style.transform',
          value: 0,
          label: 'Rotation',
        },
        {
          name: 'Border Color',
          inputType: 'color',
          binding: 'style.borderColor',
          value: 'black',
          label: 'Border Color',
        },
        {
          name: 'Border Type',
          label: 'Border Type',
          inputType: 'dropdown',
          options: [
            {
              label: 'Solid',
              value: 'solid',
            },
            {
              label: 'Dotted',
              value: 'dotted',
            },
            {
              label: 'Dashed',
              value: 'dashed',
            },
            {
              label: 'Double',
              value: 'double',
            },
            {
              label: 'Groove',
              value: 'groove',
            },
            {
              label: 'Ridge',
              value: 'ridge',
            },
            {
              label: 'Inset',
              value: 'inset',
            },
            {
              label: 'Outset',
              value: 'outset',
            },
          ],
          binding: 'style.borderStyle',
          value: 'solid',
        },
        {
          name: 'Border Radius',
          inputType: 'number',
          binding: 'style.borderRadius',
          value: '0px',
          label: 'Border Radius',
        },
        {
          name: 'Border Width',
          inputType: 'number',
          binding: 'style.borderWidth',
          value: '1px',
          label: 'Border Width',
        },
      ],
      isLocked: false,
    },
  ],
  height: null,
  width: null,
  rowCount: 300,
  colCount: 150,
  cellWidth: 3.77,
  cellHeight: 3.77,
  defaultScreenSize: {
    label: 'Desktop',
    width: 30,
    height: 15,
    unit: 1,
  },
  scale: [1, 1],
};
